<template>
  <section class="dp-layout consumption-config-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
    </section>

    <section class="dp-right">
      <div class="config-panel">
        <div v-if="DepartmentId" class="config-content">
          <el-card class="config-card settings-card" shadow="never" v-loading="settingsLoading">
            <div slot="header" class="card-header">
              <span class="title">学校消费参数</span>
              <span class="school-chip">{{ schoolName || '当前学校' }}</span>
              <el-button v-if="hasBtn('saveSchoolSettings')" size="mini" type="primary" icon="el-icon-check"
                :loading="settingsSaving" @click="saveSchoolSettings">
                保存配置
              </el-button>
            </div>
            <div class="setting-grid">
              <div class="setting-tile">
                <div class="tile-label"><i class="el-icon-coin"></i> 消费余额不足阈值</div>
                <div class="tile-control">
                  <el-input-number v-model="schoolForm.ConsumerBalanceLowThreshold" :min="20" :precision="2"
                    controls-position="right" size="small"></el-input-number>
                  <span class="unit-text">元</span>
                </div>
                <p class="tile-tip">低于该金额时提醒家长充值</p>
              </div>
              <div class="setting-tile">
                <div class="tile-label"><i class="el-icon-dish"></i> 订餐功能</div>
                <div class="tile-control">
                  <el-switch v-model="schoolForm.EnableOrderFood" active-text="开启" inactive-text="关闭"></el-switch>
                </div>
                <p class="tile-tip">开启后本校可使用订餐相关功能</p>
              </div>
              <div class="setting-tile">
                <div class="tile-label"><i class="el-icon-wallet"></i> 家长端显示专项余额</div>
                <div class="tile-control">
                  <el-switch v-model="schoolForm.ParentAppShowSubsidyWallet" active-text="开启"
                    inactive-text="关闭"></el-switch>
                </div>
                <p class="tile-tip">开启后家长可见专项钱包余额及消费明细</p>
              </div>
              <div class="setting-tile">
                <div class="tile-label"><i class="el-icon-user"></i> 人员变更自动下发老设备</div>
                <div class="tile-control">
                  <el-switch v-model="schoolForm.AutoSyncFaceToLegacyConsumerTerminal" active-text="开启"
                    inactive-text="关闭"></el-switch>
                </div>
                <p class="tile-tip">教师/学生更换头像后自动下发；删除学生或教师时自动从本校食堂消费机清空该人员</p>
              </div>
            </div>
          </el-card>

          <el-card class="config-card table-card" shadow="never" v-loading="listLoading">
            <div slot="header" class="card-header table-header">
              <span class="title">账号可见终端</span>
              <span class="header-hint">有名单则只看勾选设备，无名单则本校不限制</span>
              <div class="header-actions">
                <el-input v-model="filters.keyword" placeholder="快速定位账号..." size="mini" clearable
                  prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="handleQuery">
                </el-input>
                <el-button v-if="hasBtn('handleAdd')" type="primary" size="mini" icon="el-icon-plus"
                  @click="handleAdd">新增可见终端</el-button>
              </div>
            </div>
                        <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
                        <div class="tbl-scroll-host">
                        <el-table height="100%" :data="pagedWhiteList" border stripe size="small" style="width: 100%">
              <el-table-column type="index" width="50" align="center" label="#" :index="tableIndexMethod"></el-table-column>
              <el-table-column prop="LoginName" label="登录名" width="160" show-overflow-tooltip></el-table-column>
              <el-table-column prop="RealName" label="姓名" width="140" show-overflow-tooltip></el-table-column>
              <el-table-column label="已分配终端" min-width="280">
                <template slot-scope="scope">
                  <div v-if="!(scope.row.Devices && scope.row.Devices.length)" class="empty-inline">-</div>
                  <div v-else class="device-summary" @click="openDevicePreview(scope.row)">
                    <span v-for="item in (scope.row.Devices || []).slice(0, 2)" :key="item.Id" class="glass-tag">
                      {{ item.TerminalName || item.DeviceSerialNo }}
                    </span>
                    <el-button v-if="scope.row.Devices.length > 2" type="text" size="mini" class="more-link">
                      +{{ scope.row.Devices.length - 2 }}
                    </el-button>
                    <el-button v-else type="text" size="mini" class="more-link">查看</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button v-if="hasBtn('handleEdit')" type="text" size="small" icon="el-icon-edit"
                    @click="openEdit(scope.row)">编辑</el-button>
                  <el-button v-if="hasBtn('handleDel')" type="text" size="small" icon="el-icon-delete"
                    style="color: #f56c6c" @click="handleDel(scope.row)">删除本校限制</el-button>
                </template>
              </el-table-column>
            </el-table>
                        </div>

            <!-- 分页。参考 LeaveConfig.vue。最后更新：2026-09-08 -->
            <div class="pagination-container">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="filteredWhiteList.length">
              </el-pagination>
            </div>
          </el-card>
        </div>

        <div v-else class="no-department-tip">
          <div style="text-align: center">
            <i class="el-icon-school" style="font-size: 64px; color: #ebeef5; margin-bottom: 20px"></i>
            <p style="font-size: 14px; color: #909399;">请在左侧选择学校以维护消费配置</p>
          </div>
        </div>
      </div>
    </section>

    <el-dialog :title="editForm.isEdit ? '编辑可见终端' : '新增可见终端'" :visible.sync="editVisible" width="780px"
      append-to-body :close-on-click-modal="false" @opened="syncEditTableSelection">
      <el-form :model="editForm" label-width="90px" size="small">
        <el-form-item label="登录名" required>
          <el-input v-model="editForm.LoginName" :disabled="!!editForm.isEdit" maxlength="100" clearable
            placeholder="请输入学校账号登录名，如 SHITANG" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="本校终端" required>
          <div class="device-table-toolbar">
            <el-input v-model="editDeviceKeyword" placeholder="搜索终端名称 / 类型 / 序列号 / 安装位置" size="mini" clearable
              prefix-icon="el-icon-search" class="device-search" @input="onEditDeviceFilterChange"></el-input>
            <span class="select-count">已选 {{ (editForm.DeviceTerminalIds || []).length }} 台</span>
          </div>
          <el-table ref="editDeviceTable" :data="pagedEditDevices" border stripe size="small" row-key="Id"
            class="device-select-table" @selection-change="onEditSelectionChange"
            @row-click="onEditDeviceRowClick">
            <el-table-column type="selection" width="46" align="center"></el-table-column>
            <el-table-column prop="TerminalName" label="终端名称" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="TerminalTypeName" label="类型" width="100" align="center"></el-table-column>
            <el-table-column prop="DeviceSerialNo" label="序列号" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="InstallAddress" label="安装位置" min-width="140" show-overflow-tooltip></el-table-column>
          </el-table>
          <div v-if="filteredEditDevices.length > devicePageSize" class="view-pager">
            <el-pagination small layout="total, prev, pager, next" :current-page="editPage"
              :page-size="devicePageSize" :total="filteredEditDevices.length" @current-change="onEditPageChange">
            </el-pagination>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="editLoading" @click="submitWhiteList">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="viewVisible" width="760px" append-to-body @open="resetViewPager">
      <div slot="title" class="view-title">
        已分配终端
        <span class="view-sub">{{ viewRow.LoginName }}{{ viewRow.RealName ? '（' + viewRow.RealName + '）' : '' }}</span>
      </div>
      <div class="device-table-toolbar">
        <el-input v-model="viewDeviceKeyword" placeholder="搜索终端名称 / 类型 / 序列号 / 安装位置" size="mini" clearable
          prefix-icon="el-icon-search" class="device-search" @input="viewPage = 1"></el-input>
        <span class="select-count">共 {{ filteredViewDevices.length }} 台</span>
      </div>
      <el-table :data="pagedViewDevices" border stripe size="small">
        <el-table-column type="index" width="50" align="center" label="#"
          :index="viewIndexMethod"></el-table-column>
        <el-table-column prop="TerminalName" label="终端名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="TerminalTypeName" label="类型" width="100" align="center"></el-table-column>
        <el-table-column prop="DeviceSerialNo" label="序列号" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="InstallAddress" label="安装位置" min-width="140" show-overflow-tooltip></el-table-column>
      </el-table>
      <div v-if="filteredViewDevices.length > devicePageSize" class="view-pager">
        <el-pagination small layout="total, prev, pager, next" :current-page.sync="viewPage"
          :page-size="devicePageSize" :total="filteredViewDevices.length">
        </el-pagination>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import DepartmentPane from '../../components/DepartmentPane';
import {
  getConsumptionSchoolSettings,
  saveConsumptionSchoolSettings,
  getConsumptionSchoolDevices,
  getConsumptionSchoolWhiteList,
  saveConsumptionSchoolWhiteList,
  deleteConsumptionSchoolWhiteList
} from '../../api/modules/consumption';

export default {
  components: { DepartmentPane },
  data() {
    return {
      DepartmentId: '',
      schoolName: '',
      buttonList: [],
      filters: {
        keyword: ''
      },
      settingsLoading: false,
      settingsSaving: false,
      listLoading: false,
      schoolForm: {
        ConsumerBalanceLowThreshold: 20,
        EnableOrderFood: false,
        ParentAppShowSubsidyWallet: false,
        AutoSyncFaceToLegacyConsumerTerminal: false
      },
      whiteList: [],
      schoolDevices: [],
      page: 1,
      pageSize: 10,
      editVisible: false,
      editLoading: false,
      editForm: {
        LoginName: '',
        DeviceTerminalIds: [],
        isEdit: false
      },
      editDeviceKeyword: '',
      editPage: 1,
      devicePageSize: 8,
      editSelectionSyncing: false,
      viewVisible: false,
      viewRow: {},
      viewDeviceKeyword: '',
      viewPage: 1
    };
  },
  computed: {
    filteredWhiteList() {
      const keyword = (this.filters.keyword || '').trim().toLowerCase();
      if (!keyword) return this.whiteList;
      return this.whiteList.filter(row => {
        const loginName = (row.LoginName || '').toLowerCase();
        const realName = (row.RealName || '').toLowerCase();
        return loginName.indexOf(keyword) >= 0 || realName.indexOf(keyword) >= 0;
      });
    },
    pagedWhiteList() {
      const start = (this.page - 1) * this.pageSize;
      return this.filteredWhiteList.slice(start, start + this.pageSize);
    },
    filteredEditDevices() {
      return this.filterDevices(this.schoolDevices, this.editDeviceKeyword);
    },
    pagedEditDevices() {
      const start = (this.editPage - 1) * this.devicePageSize;
      return this.filteredEditDevices.slice(start, start + this.devicePageSize);
    },
    filteredViewDevices() {
      return this.filterDevices(this.viewRow.Devices || [], this.viewDeviceKeyword);
    },
    pagedViewDevices() {
      const start = (this.viewPage - 1) * this.devicePageSize;
      return this.filteredViewDevices.slice(start, start + this.devicePageSize);
    }
  },
  watch: {
    'filters.keyword'() {
      this.page = 1;
    },
    filteredWhiteList(list) {
      const maxPage = Math.max(1, Math.ceil((list || []).length / this.pageSize) || 1);
      if (this.page > maxPage) {
        this.page = maxPage;
      }
    },
    filteredEditDevices(list) {
      const maxPage = Math.max(1, Math.ceil((list || []).length / this.devicePageSize) || 1);
      if (this.editPage > maxPage) {
        this.editSelectionSyncing = true;
        this.editPage = maxPage;
      }
    },
    filteredViewDevices(list) {
      const maxPage = Math.max(1, Math.ceil((list || []).length / this.devicePageSize) || 1);
      if (this.viewPage > maxPage) this.viewPage = maxPage;
    }
  },
  methods: {
    hasBtn(func) {
      if (!this.buttonList || !this.buttonList.length) return true;
      return this.buttonList.some(item => item.Func === func);
    },
    matchDevice(item, keyword) {
      if (!keyword) return true;
      const key = keyword.trim().toLowerCase();
      if (!key) return true;
      const fields = [item.TerminalName, item.TerminalTypeName, item.DeviceSerialNo, item.InstallAddress];
      return fields.some(text => (text || '').toLowerCase().indexOf(key) >= 0);
    },
    filterDevices(list, keyword) {
      return (list || []).filter(item => this.matchDevice(item, keyword));
    },
    normalizeDeviceId(id) {
      const num = Number(id);
      return Number.isFinite(num) ? num : id;
    },
    onEditDeviceFilterChange() {
      this.editSelectionSyncing = true;
      this.editPage = 1;
      this.$nextTick(() => this.syncEditTableSelection());
    },
    onEditPageChange(page) {
      this.editSelectionSyncing = true;
      this.editPage = page;
      this.$nextTick(() => this.syncEditTableSelection());
    },
    onEditSelectionChange(rows) {
      if (this.editSelectionSyncing) return;
      const pageIdSet = {};
      this.pagedEditDevices.forEach(item => {
        pageIdSet[this.normalizeDeviceId(item.Id)] = true;
      });
      const selectedOnPage = (rows || []).map(item => this.normalizeDeviceId(item.Id));
      const kept = (this.editForm.DeviceTerminalIds || [])
        .map(id => this.normalizeDeviceId(id))
        .filter(id => !pageIdSet[id]);
      this.editForm.DeviceTerminalIds = kept.concat(selectedOnPage);
    },
    onEditDeviceRowClick(row, column, event) {
      if (this.editSelectionSyncing) return;
      if (column && column.type === 'selection') return;
      if (event && event.target && event.target.closest && event.target.closest('.el-checkbox')) return;
      const rowId = this.normalizeDeviceId(row.Id);
      const ids = (this.editForm.DeviceTerminalIds || []).map(id => this.normalizeDeviceId(id));
      const idx = ids.indexOf(rowId);
      const willSelect = idx < 0;
      if (willSelect) ids.push(rowId);
      else ids.splice(idx, 1);
      this.editSelectionSyncing = true;
      this.editForm.DeviceTerminalIds = ids;
      const table = this.$refs.editDeviceTable;
      if (table) table.toggleRowSelection(row, willSelect);
      this.$nextTick(() => {
        this.editSelectionSyncing = false;
      });
    },
    syncEditTableSelection() {
      const table = this.$refs.editDeviceTable;
      if (!table) {
        this.editSelectionSyncing = false;
        return;
      }
      this.editSelectionSyncing = true;
      const selectedSet = {};
      (this.editForm.DeviceTerminalIds || []).forEach(id => {
        selectedSet[this.normalizeDeviceId(id)] = true;
      });
      this.pagedEditDevices.forEach(row => {
        table.toggleRowSelection(row, !!selectedSet[this.normalizeDeviceId(row.Id)]);
      });
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.editSelectionSyncing = false;
        });
      });
    },
    resetViewPager() {
      this.viewDeviceKeyword = '';
      this.viewPage = 1;
    },
    viewIndexMethod(index) {
      return (this.viewPage - 1) * this.devicePageSize + index + 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
    },
    handleCurrentChange(val) {
      this.page = val;
    },
    tableIndexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1;
    },
    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.page = 1;
      this.handleQuery();
    },
    handleQuery() {
      if (!this.DepartmentId) {
        this.$message.warning('请选择有效学校');
        return;
      }
      this.settingsLoading = true;
      this.listLoading = true;
      Promise.all([
        getConsumptionSchoolSettings({ departmentId: this.DepartmentId }),
        getConsumptionSchoolWhiteList({ departmentId: this.DepartmentId }),
        getConsumptionSchoolDevices({ departmentId: this.DepartmentId })
      ]).then(([settingsRes, listRes, deviceRes]) => {
        this.settingsLoading = false;
        this.listLoading = false;
        if (settingsRes.data && settingsRes.data.success) {
          const data = settingsRes.data.response || {};
          this.schoolName = data.SchoolName;
          this.schoolForm.ConsumerBalanceLowThreshold = data.ConsumerBalanceLowThreshold || 20;
          this.schoolForm.EnableOrderFood = !!data.EnableOrderFood;
          this.schoolForm.ParentAppShowSubsidyWallet = !!data.ParentAppShowSubsidyWallet;
          this.schoolForm.AutoSyncFaceToLegacyConsumerTerminal = !!data.AutoSyncFaceToLegacyConsumerTerminal;
        } else {
          this.$message.error((settingsRes.data && settingsRes.data.msg) || '读取学校配置失败');
        }
        this.whiteList = (listRes.data && listRes.data.success && listRes.data.response) || [];
        this.schoolDevices = (deviceRes.data && deviceRes.data.success && deviceRes.data.response) || [];
      }).catch(() => {
        this.settingsLoading = false;
        this.listLoading = false;
      });
    },
    saveSchoolSettings() {
      if (!this.DepartmentId) {
        this.$message.warning('请选择有效学校');
        return;
      }
      this.settingsSaving = true;
      saveConsumptionSchoolSettings({
        DepartmentId: this.DepartmentId,
        ConsumerBalanceLowThreshold: this.schoolForm.ConsumerBalanceLowThreshold,
        EnableOrderFood: this.schoolForm.EnableOrderFood,
        ParentAppShowSubsidyWallet: this.schoolForm.ParentAppShowSubsidyWallet,
        AutoSyncFaceToLegacyConsumerTerminal: this.schoolForm.AutoSyncFaceToLegacyConsumerTerminal
      }).then(res => {
        this.settingsSaving = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      }).catch(() => {
        this.settingsSaving = false;
      });
    },
    handleAdd() {
      if (!this.DepartmentId) {
        this.$message.warning('请选择有效学校');
        return;
      }
      this.editForm = { LoginName: '', DeviceTerminalIds: [], isEdit: false };
      this.editDeviceKeyword = '';
      this.editPage = 1;
      this.editVisible = true;
      this.$nextTick(() => {
        if (this.$refs.editDeviceTable) this.$refs.editDeviceTable.clearSelection();
      });
      this.loadDevices();
    },
    openEdit(row) {
      this.editForm = {
        LoginName: row.LoginName || '',
        DeviceTerminalIds: (row.Devices || []).map(x => this.normalizeDeviceId(x.Id)),
        isEdit: true
      };
      this.editDeviceKeyword = '';
      this.editPage = 1;
      this.editVisible = true;
      this.loadDevices();
    },
    handleEdit() {
      this.$message.info('请在列表中点击对应账号的编辑');
    },
    openDevicePreview(row) {
      this.viewRow = row || {};
      this.viewVisible = true;
    },
    loadDevices() {
      if (!this.DepartmentId) return;
      getConsumptionSchoolDevices({ departmentId: this.DepartmentId }).then(res => {
        if (res.data && res.data.success) {
          this.editSelectionSyncing = true;
          this.schoolDevices = res.data.response || [];
          this.$nextTick(() => this.syncEditTableSelection());
        }
      });
    },
    submitWhiteList() {
      const loginName = (this.editForm.LoginName || '').trim();
      if (!loginName) {
        this.$message.warning('请输入登录名');
        return;
      }
      if (!this.editForm.DeviceTerminalIds || !this.editForm.DeviceTerminalIds.length) {
        this.$message.warning('请至少勾选 1 台终端；取消限制请使用删除本校限制');
        return;
      }
      this.editLoading = true;
      saveConsumptionSchoolWhiteList({
        DepartmentId: this.DepartmentId,
        LoginName: loginName,
        DeviceTerminalIds: this.editForm.DeviceTerminalIds
      }).then(res => {
        this.editLoading = false;
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
          this.editVisible = false;
          this.handleQuery();
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      }).catch(() => {
        this.editLoading = false;
      });
    },
    handleDel(row) {
      const target = row && row.UserId ? row : null;
      if (!target) {
        this.$message.info('请在列表中点击对应账号的删除本校限制');
        return;
      }
      this.$confirm(`确定取消 ${target.LoginName} 在本校的终端限制吗？取消后该账号在本校可看全部消费终端。`, '删除本校限制', {
        type: 'warning'
      }).then(() => {
        return deleteConsumptionSchoolWhiteList({
          DepartmentId: this.DepartmentId,
          UserId: target.UserId
        });
      }).then(res => {
        if (res && res.data && res.data.success) {
          this.$message.success(res.data.msg || '已取消本校限制');
          this.handleQuery();
        } else if (res) {
          this.$message.error((res.data && res.data.msg) || '删除失败');
        }
      }).catch(() => { });
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
.consumption-config-page.dp-layout {
  padding: 12px;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
}

.dp-layout {
  height: 100%;
}

.dp-left {
  overflow-y: auto;
}

.dp-right {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 0;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
}

.config-panel {
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.config-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
}

.settings-card {
  flex-shrink: 0;
}

.table-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.config-card {
  border-radius: 8px;
  border: 1px solid #e8edf5;
  box-shadow: none;
  margin-bottom: 0;
}

.config-card ::v-deep .el-card__header {
  padding: 10px 14px;
  border-bottom: 1px solid #eef1f6;
}

.config-card ::v-deep .el-card__body {
  padding: 12px 14px;
}

.table-card ::v-deep .el-card__header {
  flex-shrink: 0;
}

.table-card ::v-deep .el-card__body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tbl-scroll-host {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.tbl-scroll-host ::v-deep .el-table {
  height: 100% !important;
}

.tbl-scroll-host ::v-deep .el-table__header-wrapper {
  overflow: hidden !important;
}

.tbl-scroll-host ::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}

.pagination-container {
  flex-shrink: 0;
  margin-top: 12px;
  text-align: right;
}

.card-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.card-header .title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  border-left: 3px solid var(--btn-primary, #2563eb);
  padding-left: 8px;
  line-height: 1.2;
}

.school-chip {
  font-size: 12px;
  color: #475569;
  background: #f1f5f9;
  border-radius: 4px;
  padding: 2px 8px;
}

.header-hint {
  font-size: 12px;
  color: #64748b;
}

.table-header .header-actions {
  margin-left: auto;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 200px;
}

.setting-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.setting-tile {
  border: 1px solid #e8edf5;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px 12px;
  min-height: 0;
}

.tile-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}

.tile-label i {
  margin-right: 4px;
  color: var(--btn-primary, #2563eb);
}

.tile-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.unit-text {
  color: #475569;
  font-size: 13px;
}

.tile-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.no-department-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 240px;
  background: #fff;
  border-radius: 8px;
}

.device-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  cursor: pointer;
}

.more-link {
  padding: 0 4px;
  color: var(--btn-primary, #2563eb);
}

.device-table-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.device-search {
  flex: 1;
}

.select-count {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.device-select-table ::v-deep .el-table__row {
  cursor: pointer;
}

.view-title {
  font-size: 16px;
  font-weight: 600;
}

.view-sub {
  margin-left: 8px;
  font-size: 13px;
  font-weight: 400;
  color: #64748b;
}

.view-pager {
  margin-top: 10px;
  text-align: right;
}

.tags-overflow-mask {
  display: flex;
  gap: 4px;
  overflow: hidden;
}

.glass-tag {
  background: #f0f7ff;
  color: var(--btn-primary, #2563eb);
  font-size: 11px;
  padding: 1px 8px;
  border-radius: 4px;
  border: 1px solid #d9ecff;
  white-space: nowrap;
}

.luxury-badge {
  background: #64748b;
  color: #fff;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 4px;
  font-weight: 600;
  flex-shrink: 0;
}

.empty-inline {
  color: #cbd5e1;
}

.luxury-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  width: 36px;
  height: 36px;
  background: var(--btn-primary, #2563eb);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.header-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-text .prefix {
  font-size: 13px;
  color: #64748b;
}

.header-text .divider {
  color: #dcdfe6;
}

.header-text .group-name {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.luxury-body {
  padding: 8px 4px 12px;
  max-height: 400px;
  overflow-y: auto;
}

.luxury-tags-wall {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.refined-tag {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #475569;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
}

.device-check-group {
  display: flex;
  flex-direction: column;
  max-height: 320px;
  overflow: auto;
}

.device-check-group .el-checkbox {
  margin: 4px 0;
}

.empty-state-mini {
  text-align: center;
  padding: 32px;
  color: #94a3b8;
  font-size: 14px;
}

@media (max-width: 1400px) {
  .setting-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1200px) {
  .setting-grid {
    grid-template-columns: 1fr;
  }

  .table-header .header-actions {
    margin-left: 0;
    width: 100%;
  }

  .search-input {
    flex: 1;
    width: auto;
  }
}
</style>
